module.exports = __webpack_public_path__ + "static/sponsorship_img-03-a@2x-8422adec2ea735c7fc001b6537540f3a.jpg";